import styled from 'styled-components';

// Utils
import { Typography } from '../../../display/Typography';

export const TimeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spaces.l}rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.s}rem;
  }
`;

export const BreakdownContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* Alinea los inputs por su base: si una etiqueta (p.ej. "Total H.P. ·
     Actuación simultánea") ocupa 2 líneas, su input NO se cae por debajo de
     los demás — la etiqueta crece hacia arriba y los campos quedan a la misma
     altura. */
  align-items: flex-end;
  gap: ${({ theme }) => theme.spaces.l}rem;
  margin-top: 2rem;

  & > * {
    min-width: 18rem;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;

    & > * {
      min-width: 14rem;
    }
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.s}rem;

    & > * {
      min-width: 12rem;
      flex: 1 1 calc(50% - ${({ theme }) => theme.spaces.s}rem);
    }
  }
`;

export const StyledTypography = styled(Typography)`
  margin: 4rem 0 2.8rem;
`;

// Switch "Actuación simultánea": label + switch JUNTOS en una fila, hint debajo.
// Alineado a la izquierda (NO space-between) para que el switch quede pegado al
// label y no se despegue al borde derecho en pantallas anchas; aguanta los 3
// idiomas (label corto) y las 3 resoluciones (columna que no desborda).
export const SimultaneousContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
  margin-top: 2rem;
`;

// Fila superior: el label y el switch, adyacentes.
export const SimultaneousHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;
